import * as React from 'react';
import { IMarkedListItem } from '../../types/offersData';

import { SeoMarkedListItem } from './components/SeoMarkedListItem';
import * as styles from './SeoMarkedList.css';
import { UIHeading2 } from '@cian/ui-kit';

interface ISeoMarkedListProps {
  items: IMarkedListItem[];
}

export const SeoMarkedList = ({ items }: ISeoMarkedListProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <UIHeading2>Люди часто спрашивают</UIHeading2>

        <div>
          {items
            .filter(item => !item.underH1)
            .map((item, index) => {
              const id = `SeoMarkedListItem_${index}`;

              return (
                <SeoMarkedListItem
                  key={id}
                  id={id}
                  title={item.title}
                  content={item.content}
                  expandedByDefault={item.expanded}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};
